export function careersUrl(jobId?: string): string {
  const configuredOrigin = import.meta.env.VITE_PUBLIC_CAREERS_URL?.trim();
  const origin =
    configuredOrigin === undefined || configuredOrigin === ''
      ? window.location.origin
      : configuredOrigin;
  const path = jobId ? `/jobs/${encodeURIComponent(jobId)}` : '/jobs';
  return new URL(path, origin).href;
}
